import React, { useEffect, useState } from 'react';
import { Box, IconButton, Typography } from '@mui/material';

import TuneIcon from '@mui/icons-material/Tune';


function   UploadIllusionEDLSummary(props) {
    const { selectionModel, editedPlates, onAdvancedSettings, getDuplicatePlates, missingPlates } = props;

    const [frameCount, setFrameCount] = useState(0);
    const [duplicateCount, setDuplicatedCount] = useState(0);

    useEffect(() => {
        setFrameCount(
            (editedPlates.filter(plate => selectionModel.includes(plate.id)) ?? []).reduce((frameCount, plate) => {
                return frameCount
                    + ((plate?.handle ?? 0) * 2)
                    + Math.abs(
                        (plate?.cut?.at(0) ?? 0)
                        - (plate?.cut?.at(1) ?? 0)
                    );
            }, 0)
        );
        setDuplicatedCount(editedPlates?.filter(plate => getDuplicatePlates(editedPlates).map(dup => dup.id).includes(plate.id)).length ?? 0)
    }, [editedPlates]);

    return (
        <Box
            id="edl-summary"
            sx={{
                backgroundColor: '#141414',
                borderRadius: '8px',
                height: 'auto',
                mt: 2,
                p: 3,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                color: 'white',
                position: 'relative'
            }} >
            <Typography 
                variant="h6" 
                sx={{ 
                    position: 'absolute', 
                    top: '8px', 
                    left: '50%', 
                    transform: 'translateX(-50%)' 
                }}
            >
                {`Summary`}
            </Typography>
            <Box display='flex'
                sx={{ width: '100%', justifyContent: 'space-between' }}>
                <Box id="edl-summary-details"
                    sx={{ mt: 4, width: '50%' }}>
                    <Typography sx={{ fontSize: 14, fontWeight: 'medium' }} >
                        Plate Count: {editedPlates?.length === selectionModel?.length ? selectionModel?.length : `${selectionModel?.length} / ${editedPlates?.length}`}
                    </Typography>
                    <Typography sx={{ fontSize: 14, fontWeight: 'medium' }} >
                        Total Frames: {frameCount}
                    </Typography>
                    <Typography sx={{ fontSize: 14, fontWeight: 'medium', color: missingPlates?.length ?? 0 > 0 ? 'red' : 'white'}} >Missing Shots: {missingPlates?.length ?? 0}</Typography>
                    <Typography sx={{ fontSize: 14, fontWeight: 'medium', color: duplicateCount > 0 ? 'red' : 'white'}} >Duplicate Plates: {duplicateCount}</Typography>
                </Box>
                {editedPlates?.length !== 0 && (
                    <Box id="edl-summary-advanced"
                        sx={{ mt: 4, width: '50%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                        <Box
                            sx={{
                                backgroundColor: '#54a277',
                                borderRadius: '50%',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: 50,
                                height: 50,
                            }}
                        >
                            <IconButton onClick={onAdvancedSettings} sx={{ color: 'white' }}>
                                <TuneIcon sx={{ fontSize: 38 }} />
                            </IconButton>
                        </Box>
                        <Typography sx={{ mt: 1, fontSize: 14, color: 'gray' }}>Modify Pull</Typography>
                    </Box>
                )}
            </Box>
        </Box>
    );
}

export default UploadIllusionEDLSummary;